<script>
  import SectionHeader from '../components/SectionHeader.svelte';
  import { fade } from 'svelte/transition';
  import { getCSVRecords } from '../services/csv-sync-service';
  import { Progress } from 'sveltestrap';
  import { ServiceState } from '../constants.js';
  import { UpdaterService } from '../services/updater-service.js';
  import { toast, stickyToast,  clearToasts} from '../components/Toast.svelte';

  let files;
  let filename;

  const updaterService = UpdaterService();

  $: syncProgress = $updaterService.status === ServiceState.IDLE ?
    0 :
    ($updaterService.record / $updaterService.records) * 100;

  const process = () => {
    clearToasts();
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const updates = getCSVRecords(reader.result);
        await updaterService.sync(updates);
        toast('success', 5000, 'Success', 'Update was successfully completed.');
      } catch(err) {
        stickyToast('danger', 'Error', `An error occured while syncing with UBMax. Please verify username/password. If this
        error persists please contact customer support`);
      }
    };
    // start reading the file. When it is done, calls the onload event defined above.
    reader.readAsBinaryString(files[0]);
  }

  $: filename = files ? files[0].name : 'Select file...';
</script>

<div in:fade="{{duration: 1000}}">
  <SectionHeader section='Residents' subsection='Import'>
  </SectionHeader>
  <div class='row'>
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="alert alert-primary no-border-radius" role="alert">
            <h4 class="alert-heading">Update Residents with CSV upload</h4>
            <p>This process will add new residents, update existing residents and remove residents.</p>
          </div>
          <form class="forms-sample">
            <div class='row fix-margins'>
              <div class="form-group col-md-12">
                <input type="file" class="custom-file-input" id="customFile" bind:files>
                <label class="custom-file-label" for="customFile">{filename}</label>
              </div>
            </div>
            <button 
              type="submit" 
              class="btn btn-primary mr-2"
              class:disabled={!files}  
              on:click|preventDefault={process}>
                Start Import
              </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <strong>Status:</strong> {$updaterService.status}
</div>
<div class='row'>
  <div class='col-md-12'>
    {#if $updaterService.status != ServiceState.IDLE}
      <div class='text-center'>{$updaterService.record} of {$updaterService.records}</div>
    {/if}
    <Progress animated value={syncProgress} style="height: 20px;">{syncProgress}%</Progress>
  </div>
</div>

<style>
  .fix-margins {
    margin-right: 0px;
    margin-left: 0px;
  }
</style>